/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Header, Icon, Select} from '@scuf/common';
import {Routes} from '../utils/Routes'
import * as SecurityActions from '../security/SecurityActions'
import {injectIntl, FormattedMessage} from 'react-intl';
import LanguagePicker from '../lang/LanguagePicker'
import AboutWindow from '../about/AboutWindow'
import {ACTIVITY_TYPES} from "../security/SecurityConst";
import HelpWindow from "../about/HelpWindow";
import {userHasActivity} from "../security/SecurityUtils";
import {ASSETS_DATA_SET_TYPE} from "../admin/assets/AssetsConst";
import {verifyAirtimeException} from "../utils/Helpers";
import * as Fleets from "../api/Fleets";
import * as Airtime from "../api/Airtime";
import * as Assets from "../api/Assets";
import {FAULT_STATES} from "../faults/common/FaultsConst";
import * as Faults from "../api/Faults";
import honAeroLogo from "../styling/images/HoneywellAeroLogo.png"

class AppHeader extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            aboutModalOpen: false,
            logoWidth: 0,
            fullData: [],
            apiPoint: userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ? Airtime : Assets,
            selectedData: "",
        }

        this.handleSignOut = this.handleSignOut.bind(this)
        this.handleLanguageHeaderItemClick = this.handleLanguageHeaderItemClick.bind(this)
        this.handleAboutHeaderItemClick = this.handleAboutHeaderItemClick.bind(this)
        this.handleAdministration = this.handleAdministration.bind(this)
    }

    handleSignOut() {
        const {Security, history} = this.props
        Security.signOut()
        history.push(Routes.LOGIN)
    }

    handleAdministration() {
        const {history} = this.props
        history.push(Routes.USERS)
    }

    generateLoginInfo(disabled) {
        const {userProfile, build} = this.props
        let adminField = null
        if (userProfile.activities.includes(ACTIVITY_TYPES.CONFIG_READ) && userProfile.activities.includes(ACTIVITY_TYPES.USERS_READ)) {
            adminField =
                <Header.Item onClick={this.handleAdministration} className="header-item" disabled={disabled}>
                    <Icon room="building" name="settings"/>
                    <FormattedMessage id="administration" />
                </Header.Item>
        }
        return (
            <Header.UserProfile firstName={userProfile.firstName} lastName={userProfile.lastName}>
                {!build.isSingleLanguage ?
                    <Header.Item onClick={this.handleLanguageHeaderItemClick} className="header-item"
                                 disabled={disabled}>
                        <Icon root="building" name="globe"/>
                        <LanguagePicker/>
                    </Header.Item>
                    : null
                }
                {adminField}
                <Header.Item onClick={this.handleAboutHeaderItemClick} className="header-item" disabled={disabled}>
                    <Icon root="building" name="badge-info"/>
                    <AboutWindow open={this.state.aboutModalOpen}/>
                </Header.Item>
                <Header.UserProfile.Item onClick={this.handleSignOut} className="header-item">
                    <Icon root="building" name="export"/>
                    <FormattedMessage id="header.logout" />
                </Header.UserProfile.Item>
            </Header.UserProfile>
        )
    }

    //hack so that the whole header item is clickable, it find the true clickable component from LanguagePicker and triggers a click
    handleLanguageHeaderItemClick(event) {
        if (event.target.classList.contains('header-item')) {
            document.getElementsByClassName("language-picker-trigger")[0].click()
        }
    }

    //hack so that the whole header item is clickable, it find the true clickable component from LanguagePicker and triggers a click
    handleAboutHeaderItemClick(event) {
        if (event.target.classList.contains('header-item')) {
            document.getElementsByClassName("about-window-trigger")[0].click()
        }
    }

    generateNavItem(navigationItem, key, disabled) {
        if (navigationItem.getName() !== '') {
            //return text navigation item
            return (
                <Header.Item key={navigationItem.getName()}
                             content={navigationItem.getName()}
                             onClick={navigationItem.onClick}
                             active={navigationItem.isActive()}
                             className="nav-item"
                             disabled={disabled}
                />

            )
        }
        if (navigationItem.getIcon() !== '') {
            //return icon navigation item
            return (
                <Header.IconItem key={navigationItem.getIcon()}
                                 icon={navigationItem.getIcon()}
                                 onClick={navigationItem.onClick}
                                 active={navigationItem.isActive()}
                                 description={navigationItem.description}
                                 className="nav-item"
                                 disabled={disabled}
                />

            )
        }
        return null
    }

    componentDidMount() {
        const iconLogo = document.getElementsByClassName("item logo-item")
        this.setState({logoWidth: iconLogo[0].offsetWidth + 50})
        this.fetchAssets()
    }

    fetchAssets() {
        const {userProfile} = this.props
        const point = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ? Airtime : Faults

        this.setState({loading: true})

        if (userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            this.state.apiPoint.fetchAssets(ASSETS_DATA_SET_TYPE.SHALLOW).then(assets => {
                point.fetchFaultsWithoutPagination(Object.values(FAULT_STATES),
                    this.state.search, this.state.sort, null)
                    .then(faults => {
                        this.setState({
                            fullData: faults.results.map(fault => {
                                return {text: fault.name + " " + fault.primarySymptom.name, value: "FR_" + fault.id + "_" + fault.asset.id, type: "FR"}
                            }).concat(
                                assets.map(asset => {
                                    return {text: asset.name, value: "EN_" + asset.id}
                                })), loading: false
                        })
                    })
            }).catch(ex => {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            })
        } else {
            Fleets.fetchHierarchy(true).then(response => {
                    this.setState({
                        fullData: response,
                        loading: false,
                    })

                }
            )
        }
    }

    goToFault(faultId, assetId) {
        const {history, userProfile} = this.props
        userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ?
            history.push(`/airtime/asset/${assetId}/faults/${faultId}`)
            :
            history.push(`/assets/${assetId}/faults/${faultId}`)
    }

    goToAsset(assetId) {
        const {history, userProfile} = this.props
        userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ?
            history.push(`/airtime/asset/${assetId}`)
            :
            history.push(`/assets/${assetId}`)
    }

    getSelector() {
        const {intl} = this.props

        return (
            <Select className={"main-navbar--search-bar"}
                placeholder={intl.formatMessage({id: "page.header.select"})}
                options={this.state.fullData}
                value={this.state.selectedData}
                search={true}
                fluid
                onChange={(data) => {
                    if (data.split("_")[0] === "EN") {
                        this.goToAsset(data.split("_")[1]);
                    } else if (data.split("_")[0] === "FR") {
                        this.goToFault(data.split("_")[1], data.split("_")[2])
                    }
                }}
            />
        )
    }

    render() {
        const {location, userProfile, build} = this.props
        const hda = build.isHdaEnvironment === 'true'
        // When airtime/camp user is on new engine creation page (AirtimeDataLoader.js) do not show the hamburger menu (mobile view)
        // or disable all the navigation items (desktop view)
        const disabled = location.pathname === '/airtime/process'
        return (
            <Header title="Diagnostics" logoUrl={honAeroLogo}
                    menu={disabled ? false : this.props.leftMenu}
                    onMenuToggle={this.props.onMenuToggle}>
                <div style={{width: "calc(100vw - " + this.state.logoWidth + "px)"}} className={"main-navbar"}>
                    <div className={"main-navbar--menu"}>
                        {
                            this.props.leftMenu ?
                                ''
                                :
                                this.props.navItems.map((i, key) => this.generateNavItem(i, key, disabled))

                        }
                    </div>
                    <div className={"main-navbar--menu"}>
                        <div className={"main-navbar--search-bar"}>
                            {this.getSelector()}
                        </div>

                        <div className="navbar-icon" onClick={() => this.props.navigate(Routes.NOTIFICATIONS)}>
                            <Icon root="common" name="notification" size="large"/>
                        </div>

                        {
                            userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ?
                                <HelpWindow role={this.props.userProfile.roles[0].name}/>
                                :
                                ''
                        }
                        {this.generateLoginInfo(disabled)}

                    </div>
                </div>
            </Header>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
        build: state.version.build,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        Security: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(AppHeader)))